import BaseInput from "../../../baseComponents/baseInput.js";
import BaseButton from "../../../baseComponents/baseButton.js";
import BaseParagraph from "../../../baseComponents/baseParagraph.js";
import BaseHyperlink from "../../../baseComponents/baseHyperlink.js";
import React, { useRef, useEffect, useState } from "react";
import LoginTemplate from "../LoginTemplate.js";
import { useDispatch, useSelector } from "react-redux";
import {
  actions as loginActions,
  asyncActions as loginAsyncActions,
} from "../../../store/slices/loginSlice.js";

import { loginId, incrementLoginId } from "../LoginTemplate";
import SignInSocialNetwork from "../../../components/SignInSocialNetwork.js";

import AppleLogin from "react-apple-login";
import { useLocation } from "react-router-dom";

const useSocialNetworkLogin =
  process.env.REACT_APP_SIGN_IN_SOCIAL_NETWORK === "true";
console.log("g", useSocialNetworkLogin);

const LoginView = ({
  title,
  autoRelogin = true,
  afterLoginRoutesPath = [],
}) => {
  ///////////////////////////////////////////////////////////////////DISPATCHER
  const dispatch = useDispatch();
  ///////////////////////////////////////////////////////////////////REFS
  const emailRef = useRef();
  ///////////////////////////////////////////////////////////////////REDUX STATES
  const loginState = useSelector((state) => state.loginState);
  const loadingState = useSelector((state) => state.loadingState);

  ///////////////////////////////////////////////////////////////////LOCAL STATES
  const [userNameInput, setUserNameInput] = useState("");
  const [passwordInput, setPasswordInput] = useState("");
  const location = useLocation();

  ///////////////////////////////////////////////////////////////////HANDLING FUNCTIONS
  const handleUserNameInputState = (e) => {
    clearLoginError();
    setUserNameInput(e.target.value);
  };

  const handlePasswordInputState = (e) => {
    clearLoginError();
    setPasswordInput(e.target.value);
  };

  const appleResponse = (response) => {
    console.log(response);
  };

  const fbLoginTemp = async () => {
    const FB_APP_ID = "2240074909657462";
    const FB_REDIRECT_URI = "http://localhost:3000/socialNetworkOauth";
    const fbLoginUrl = `https://www.facebook.com/v12.0/dialog/oauth?client_id=${FB_APP_ID}&redirect_uri=${FB_REDIRECT_URI}&state=myState&scope=email,public_profile`;

    window.location.href = fbLoginUrl;
  };

  ///////////////////////////////////////////////////////////////////EFFECTS

  /*
    clear errors on mount
  */
  useEffect(() => {
    clearLoginError();
  }, []);

  /* 
  focus email field on start
  */

  ///////////////////////////////////////////////////////////////////METODE
  const clearLoginError = () => {
    if (loginState.login.error.errorMsg) {
      dispatch(loginActions.resetLoginError());
    }
  };

  const login = async () => {
    incrementLoginId();
    const res = await dispatch(
      loginAsyncActions.login({
        username: userNameInput,
        password: passwordInput,
        loginId: loginId,
      })
    );

    if (res.error) {
      return false;
    }

    let resFromDB = {};
    try {
      resFromDB = JSON.parse(res.payload?.P_RESULT);
    } catch (err) {}

    return resFromDB.isSuccess ?? false;
  };

  ///////////////////////////////////////////////////////////////////RENDER
  return (
    <LoginTemplate
      heading={title}
      onEnter={login}
      success={loginState.login.success.successMsg}
      focusElement={emailRef}
      autoRelogin={autoRelogin}
      afterLoginRoutesPath={afterLoginRoutesPath}
    >
      <BaseInput
        value={userNameInput}
        onChange={handleUserNameInputState}
        type="email"
        placeholder="emailAdressOrPhoneNumber"
        innerRef={emailRef}
      />
      <BaseInput
        value={passwordInput}
        onChange={handlePasswordInputState}
        type="password"
        placeholder="password"
      />
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "flex-end",
        }}
      >
        <BaseHyperlink bold style={{ fontSize: "19px" }} to="/forgotPassword">
          forgotPasswordQuestion
        </BaseHyperlink>
      </div>

      {/* 
      <AppleLogin
        clientId="hr.ipc.holdinaloyalty.siwa.sid"
        // redirectURI="https://frontend.inaepclub.ba/socialNetworkOauth"
        redirectURI='https://frontend-loyalty-test.ipc.hr'
        callback={appleResponse}
        scope="email name"
        responseMode="form_post"
      /> */}

      <BaseButton error={loginState.login.error.errorMsg} onClick={login}>
        logIn
      </BaseButton>

      <SignInSocialNetwork type="Google" />
      <SignInSocialNetwork type="Facebook" />

      {/* <BaseButton onClick={fbLoginTemp} translate={false}>
        FEJS
      </BaseButton> */}

      <div
        style={{
          marginTop: "1.5em",
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <BaseParagraph>newToSystemquestion</BaseParagraph>
        <BaseHyperlink bold to="/register" style={{ fontSize: "19px" }}>
          register
        </BaseHyperlink>
      </div>
    </LoginTemplate>
  );
};

export default LoginView;
